var _defs, _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmoLinkedInIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #0077b7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,0H16.3C7.3,0,0,7.3,0,16.3v147.4c0,9,7.3,16.3,16.3,16.3h147.4c9,0,16.3-7.3,16.3-16.3V16.3c0-9-7.3-16.3-16.3-16.3ZM55.7,155.4c0,2.6-2.1,4.7-4.7,4.7h-20.2c-2.6,0-4.7-2.1-4.7-4.7v-84.5c0-2.6,2.1-4.7,4.7-4.7h20.2c2.6,0,4.7,2.1,4.7,4.7v84.5ZM40.9,58.2c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2,19.2,8.6,19.2,19.2-8.6,19.2-19.2,19.2ZM161.1,155.8c0,2.4-2,4.3-4.4,4.3h-21.6c-2.4,0-4.4-1.9-4.4-4.3v-39.7c0-5.9,1.7-25.9-15.5-25.9s-16,13.7-16.6,19.8v45.8c0,2.4-2,4.3-4.4,4.3h-20.9c-2.4,0-4.4-1.9-4.4-4.3v-85.3c0-2.4,2-4.4,4.4-4.4h20.9c2.4,0,4.4,2,4.4,4.4v7.4c5-7.4,12.3-13.2,28-13.2,34.7,0,34.5,32.4,34.5,50.2v40.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,39c0,10.6-8.6,19.2-19.2,19.2s-19.2-8.6-19.2-19.2,8.6-19.2,19.2-19.2,19.2,8.6,19.2,19.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 26,
    y: 66.1,
    width: 29.7,
    height: 94,
    rx: 4.7,
    ry: 4.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.1,114.9v40.9c0,2.4-2,4.3-4.4,4.3h-21.6c-2.4,0-4.4-1.9-4.4-4.3v-39.7c0-5.9,1.7-25.9-15.5-25.9s-16,13.7-16.6,19.8v45.8c0,2.4-2,4.3-4.4,4.3h-20.9c-2.4,0-4.4-1.9-4.4-4.3v-85.3c0-2.4,2-4.4,4.4-4.4h20.9c2.4,0,4.4,2,4.4,4.4v7.4c5-7.4,12.3-13.2,28-13.2,34.7,0,34.5,32.4,34.5,50.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmoLinkedInIcon1);
export default __webpack_public_path__ + "static/media/OMO-LinkedIn-Icon (1).1397532c00a70cfb872bc41d1953c82c.svg";
export { ForwardRef as ReactComponent };